import { render, staticRenderFns } from "./customerSalesPrices.vue?vue&type=template&id=11fb5a8a&"
import script from "./customerSalesPrices.vue?vue&type=script&lang=js&"
export * from "./customerSalesPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports